import { Component } from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';

@Component({
    selector: 'custom-stepper',
    templateUrl: './custom-stepper.component.html',
    styleUrls: ['./custom-stepper.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: CustomStepperComponent }],
    standalone: false
})
//extends CdkStepper implements OnInit
export class CustomStepperComponent {
  // constructor(
  //   _dir: Directionality,
  //   _changeDetectorRef: ChangeDetectorRef,
  //   private eventBus: EventBusService
  // ) {
  //   super(_dir, _changeDetectorRef,);
  // }
  // ngOnInit() {
  //   this.selectedIndex = this.eventBus.getStep() - 1;
  // }
  // onClick(index: number): void {
  //   this.selectedIndex = index;
  //   this.eventBus.setStep(this.selectedIndex + 1);
  // }
}
